const FamilyDiseases = ({
  familyDiseases,
  handleFamilyHistoryChange,
  isNext,
}) => {
  return (
    <div>
      {/* Header */}
      <div className="mb-4">
        <label className="block text-base font-medium text-black col-span-1">
          Please check if you or your blood relatives have any of the following conditions:
        </label>
        <div className="flex justify-end items-center gap-4">
          <span className="text-base font-medium text-black">Yes</span>
          <span className="text-base font-medium text-black">No</span>
        </div>
      </div>

      {/* Disease Rows */}
      {Object.keys(familyDiseases).map((disease) => (
        <div
          key={disease}
          className="flex items-center justify-between mb-4"
        >
          {/* Disease Name */}

          <label className="text-base font-medium text-black w-1/4">
            {disease} {" "}
            <span className="text-red-500">*</span>
          </label>

          {/* Relationship Input */}
          <input
            type="text"
            value={familyDiseases[disease]?.relationship || ""}
            onChange={(e) =>
              handleFamilyHistoryChange(
                "familyDiseases",
                disease,
                "relationship",
                e.target.value
              )
            }
            placeholder="relationship"
            disabled={isNext}
            className={`${isNext ? "!text-black !opacity-100" : ""}
              border-b border-gray-400 font-medium
              border-t-0 border-l-0 border-r-0
              focus:outline-none focus:border-blue-600
              px-2 py-1 w-1/3 bg-slate-50`}
          />

          {/* Yes / No Checkboxes */}
          <div className="flex items-center gap-4">
            {/* Yes */}
            <input
              type="checkbox"
              checked={familyDiseases[disease]?.hasDisease === "Yes"}
              onChange={() =>
                handleFamilyHistoryChange(
                  "familyDiseases",
                  disease,
                  "hasDisease",
                  "Yes"
                )
              }
              disabled={isNext}
              className="form-radio h-5 w-5 text-blue-600 border-gray-700 rounded"
            />

            {/* No */}
            <input
              type="checkbox"
              checked={familyDiseases[disease]?.hasDisease === "No"}
              onChange={() =>
                handleFamilyHistoryChange(
                  "familyDiseases",
                  disease,
                  "hasDisease",
                  "No"
                )
              }
              disabled={isNext}
              className="form-radio h-5 w-5 text-blue-600 border-gray-700 rounded" />
          </div>
        </div>
      ))}
    </div>
  );
};
export default FamilyDiseases;